import { render } from "./ProfileSchemajson.vue?vue&type=template&id=8235709a"
import script from "./ProfileSchemajson.vue?vue&type=script&lang=js"
export * from "./ProfileSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__